export default __webpack_public_path__ + "static/media/creditCardIcon.294415dd.svg";